export default __webpack_public_path__ + "static/media/cookies.41dc018e.jpg";